import type PrivateParserContext from "../../../../core/Parser/ParserContext/PrivateParserContext";
import linkCreator from "../../render/logic/linkCreator";

function linkToken(context?: PrivateParserContext) {
	return {
		mark: "link",
		getAttrs: async (tok) => {
			const title = tok.attrGet("title") || null;
			if (!context) return { href: tok.attrGet("href"), hash: "", resourcePath: "", title };
			const { href, resourcePath, hash, isFile } = await linkCreator.getLink(tok.attrGet("href"), context);

			if (resourcePath) {
				if (isFile) context.getResourceManager().set(resourcePath);
				else context.getLinkManager().set(resourcePath, hash);
			}
			return {
				href,
				isFile,
				hash: hash ?? "",
				resourcePath: resourcePath?.value ?? "",
				title,
			};
		},
	};
}

export default linkToken;
